<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" SearchC>
          <Search 
            :loading="loading"
            :resourceSettings="resourceSettings" 
            @searchResource="searchResource" 
            @create="dialog = true"
          />
        </v-col>
        <v-col cols="12" PagingC>
          <Paging 
            :resourceSettings="resourceSettings" 
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0 mb-2 elevation-2 px-2 align-center py-3" 
                v-for="(r, i) in resource.data" :key="'resource-'+i"  style="cursor:pointer;">
                <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} pa-0`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" v-if="r.created_at">
                        <v-chip label color="secondary" dark small><v-icon size="10" left>public</v-icon>
                        <span style="text-transform:uppercase;">{{r.user_country ? r.user_country : 'SYSTEM'}}</span></v-chip>
                      </span>
                    </template>
                    <div class="text-center">
                      <div v-if="r.created_at" :class="`${arabic?'arFont':'enFont'} pa-0`">{{r.user ? r.user : 'SYSTEM'}}</div>
                    </div>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" md="3" :class="`${arabic?'arFont':'enFont'} pa-0`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" v-if="r.created_at">
                        <v-chip label small><v-icon size="10">date_range</v-icon>
                        {{r.created_at.split(' ')[0]}} |
                        <v-icon size="10">schedule</v-icon>
                        {{r.created_at.split(' ')[1].split('.')[0]}}</v-chip>
                      </span>
                    </template>
                    <div class="text-center">
                      <div v-if="r.created_at" :class="`${arabic?'arFont':'enFont'} pa-0`">{{getFormat(r.created_at)}}</div>
                    </div>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'} pa-0`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" v-if="r.created_at">
                        <v-chip label small><v-icon size="10" left>person</v-icon>
                        <span style="text-transform:uppercase;">{{r.user ? r.user : 'SYSTEM'}}</span></v-chip>
                      </span>
                    </template>
                    <div class="text-center">
                      <div v-if="r.created_at" :class="`${arabic?'arFont':'enFont'} pa-0`">{{r.user_country ? r.user_country : 'SYSTEM'}}</div>
                    </div>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" md="2" :class="`${arabic?'arFont':'enFont'} pa-0`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" v-if="r.created_at">
                        <v-chip label color="secondary" dark small>
                          <v-icon size="10" left v-if="r.description == 'created'">add_circle_outline</v-icon>
                          <v-icon size="10" left v-else>update</v-icon>
                        <span style="text-transform:uppercase;">{{r.description}}</span></v-chip>
                      </span>
                    </template>
                    <div class="text-center">
                      <div v-if="r.created_at" :class="`${arabic?'arFont':'enFont'} pa-0`">{{r.properties}}</div>
                    </div>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} pa-0 pt-1 font-weight-bold`">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <span class="font-weight-light">lead with name </span>
                        {{r.name}} <span class="font-weight-light"> with phone {{r.phone}} and email {{r.email}} </span> was <span style="color:red;">{{r.description}}</span>
                        <span v-if="r.status"><span class="font-weight-light" > new status: </span> {{r.status}}</span>
                        <span v-if="r.program"><span class="font-weight-light" > new program: </span> {{r.program}}</span>
                      </span>
                    </template>
                    <div class="text-center">
                      <div :class="`${arabic?'arFont':'enFont'}`">{{r.properties}}</div>
                    </div>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: { Search, Paging },
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        {name: 'company', label:'company', type:'text', required:true },
        {name: 'program', label:'program', type:'text', required:true },
        {name: 'email', label:'email', type:'text', required:true },
      ],
      resourceSettings:{
        resourceName:null,
        search:true,
        create:false,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      templates:[],
      lists:[],
    }
  },
  
  methods: {
    validate(newResource, notify) {
      let fsr = this.resourceKeys.filter(x=>x.required)
      let fse = this.resourceKeys.filter(x=>x.email)
      let v = true
      fsr.forEach(x=>{
        if(!newResource[x.name]) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.required}`, 'error')
        }
      })
      fse.forEach(x=>{
        if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(newResource[x.name])) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.valid_email}`, 'error')
        }
      })
      return v
    },
    getItems(items) {
      return this[items]
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        }
        this.loading = false
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}`})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    async searchResource(search){
      return new Promise(async (res, rej)=>{
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        this.loading = false
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('putResource', {resource:this.$route.path + `/${r.id}`, value:r})
        this.dialog = false
        this.editing = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:this.$route.path + `/${r.id}`})
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        await this.$store.dispatch('postResource', {resource:this.$route.path + `${r.id ? '/' + r.id : ''}`, value:r})
        this.dialog = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    }
  },
  watch:{
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    await this.loadResource()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>